import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconAdjustVisuals: React.FC<IconProps> = ({ width = 28, height = 28, color = 'black' }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 28 28"
            fill="none"
        >
            <g clip-path="url(#clip0_10693_1825)">
                <path
                    d="M8.42206 12.7983H10.2792C10.6812 12.7983 11.0114 12.4679 11.0114 12.0673V10.2096C11.0114 9.80875 10.6812 9.47852 10.2792 9.47852H8.42206C8.01899 9.47852 7.69141 9.80705 7.69141 10.2096V12.0673C7.69141 12.4679 8.0188 12.7983 8.42206 12.7983Z"
                    fill={color}
                />
                <path
                    d="M14.1536 10.6344H16.3931C16.8783 10.6344 17.2732 10.2384 17.2732 9.75431V7.5153C17.2732 7.03085 16.8783 6.63574 16.3931 6.63574H14.1536C13.6695 6.63574 13.2734 7.03085 13.2734 7.5153V9.75431C13.2734 10.2382 13.6697 10.6344 14.1536 10.6344Z"
                    fill={color}
                />
                <path
                    d="M15.8195 18.1533H13.5793C13.0955 18.1533 12.6992 18.5484 12.6992 19.0336V21.2732C12.6992 21.7548 13.0955 22.1522 13.5793 22.1522H15.8195C16.3022 22.1522 16.6996 21.7548 16.6996 21.2732V19.0336C16.6994 18.5507 16.3022 18.1533 15.8195 18.1533Z"
                    fill={color}
                />
                <path
                    d="M19.6943 16.2003V13.4885C19.6943 12.9018 19.2161 12.4219 18.6294 12.4219H15.9176C15.332 12.4219 14.8516 12.9018 14.8516 13.4885V16.2003C14.8516 16.7861 15.332 17.2665 15.9176 17.2665H18.6294C19.2152 17.2665 19.6943 16.7861 19.6943 16.2003Z"
                    fill={color}
                />
                <path
                    d="M19.0345 4.57203H20.2957C20.5671 4.57203 20.7923 4.34839 20.7923 4.07658V2.81576C20.7923 2.54376 20.5681 2.32031 20.2957 2.32031H19.0345C18.7642 2.32031 18.5391 2.54376 18.5391 2.81576V4.07639C18.5391 4.34858 18.7642 4.57203 19.0345 4.57203Z"
                    fill={color}
                />
                <path
                    d="M23.5457 14.1094H22.2845C22.0117 14.1094 21.7891 14.3328 21.7891 14.6062V15.8668C21.7891 16.1395 22.0119 16.3636 22.2845 16.3636H23.5457C23.8171 16.3636 24.04 16.1416 24.04 15.8668V14.6062C24.04 14.3328 23.8183 14.1094 23.5457 14.1094Z"
                    fill={color}
                />
                <path
                    d="M13.2321 15.4828C13.4601 15.4828 13.6508 15.2935 13.6508 15.0648V13.9993C13.6508 13.7683 13.4601 13.5801 13.2321 13.5801H12.165C12.1441 13.5801 12.1333 13.6002 12.1096 13.6044V4.82801L3.92393 0.777344H1.64453V27.444H3.92393L12.1094 17.3169V15.462C12.1331 15.4642 12.1441 15.4851 12.1648 15.4851H13.2319L13.2321 15.4828ZM11.0971 16.9565L4.93644 24.5773V2.40577L11.0971 5.4551V16.9565Z"
                    fill={color}
                />
                <path
                    d="M20.8272 18.1533H19.76C19.5313 18.1533 19.3418 18.3428 19.3418 18.5727V19.6363C19.3418 19.8675 19.5302 20.0568 19.76 20.0568H20.8247C21.0546 20.0568 21.2441 19.8675 21.2441 19.6363V18.5727C21.2452 18.3428 21.0559 18.1533 20.8272 18.1533Z"
                    fill={color}
                />
                <path
                    d="M24.7338 5.92578H21.0966C20.3102 5.92578 19.668 6.56918 19.668 7.3558V10.9916C19.668 11.7763 20.3102 12.4216 21.0966 12.4216H24.7338C25.5213 12.4216 26.1647 11.7765 26.1647 10.9916V7.35561C26.1647 6.56899 25.5213 5.92578 24.7338 5.92578Z"
                    fill={color}
                />
            </g>
            <defs>
                <clipPath id="clip0_10693_1825">
                    <rect
                        width="26.6668"
                        height="26.6666"
                        fill="white"
                        transform="translate(0.570312 0.777344)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconAdjustVisuals;
